import { render, staticRenderFns } from "./AddToCartWrapper.vue?vue&type=template&id=57f152d8"
import script from "./AddToCartWrapper.vue?vue&type=script&lang=ts"
export * from "./AddToCartWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports